<template>
    <div class="cont-result-faq margin-general">
        <NuxtLink :to="localPath('/faq')" class="back-link">
            <span data-v-b04161ba="" class="material-symbols-outlined" translate="no">chevron_left</span>
            {{ $t("faq.goback") }}
        </NuxtLink>
        <div class="sub-cont">
            <FaqAccordion>
                <div class="accordeon container movil">
                    <div class="content-main-tab">
                        <div class="tab-content">
                            <div class="contet-general">
                                <h4 role="heading" aria-level="1">{{ $t("faq.tab2.title1") }}</h4>
                                <div class="icon-text">
                                    <div class="cont-icon">
                                    <span class="material-symbols-outlined icon" translate="no">link</span>
                                    <div class="list-number"><span>1.</span></div>
                                    </div>
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4"><span v-html="formatContent('faq.tab2.text1', $t, localPath)"></span></p>
                                    </div>
                                    </div>
                                </div>
                                <div class="icon-text">
                                    <div class="cont-icon">
                                    <span class="material-symbols-outlined icon" translate="no">variable_insert</span>
                                    <div class="list-number"><span>2.</span></div>
                                    </div>
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4"><span >{{ $t("faq.tab2.text2") }}</span></p>
                                        <picture class=""><source media="(max-width: 570px)" srcset="/images/faq/New-user-guide-q2-01-movil.jpg"><img src="/images/faq/New-user-guide-q2-01.jpg" alt="Imagen 1" class="responsive-image"></picture>
                                        <p class="body-4"><span class="italic">{{ $t("faq.tab2.text3") }}</span></p>
                                        <!-- <p class="body-4"><span class="italic">{{ $t("faq.tab2.text4") }}</span></p>
                                        <p class="body-4"><span class="italic">{{ $t("faq.tab2.text5") }}</span></p> -->
                                    </div>
                                    </div>
                                </div>
                                <div class="icon-text">
                                    <div class="cont-icon">
                                    <span class="material-symbols-outlined icon" translate="no">password</span>
                                    <div class="list-number"><span>3.</span></div>
                                    </div>
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4"><span v-html="formatContent('faq.tab2.text6', $t, localPath)"></span></p>
                                        <picture class=""><source media="(max-width: 570px)" srcset="/images/faq/New-user-guide-q2-02-movil.jpg"><img src="/images/faq/New-user-guide-q2-02.png" alt="Imagen 1" class="responsive-image"></picture>
                                        <picture class=""><source media="(max-width: 570px)" srcset="/images/faq/New-user-guide-q2-03-movil.jpg"><img src="/images/faq/New-user-guide-q2-03.png" alt="Imagen 1" class="responsive-image"></picture>
                                    </div>
                                    </div>
                                </div>
                                <div class="icon-text">
                                    <div class="cont-icon">
                                    <span class="material-symbols-outlined icon" translate="no">clarify</span>
                                    <div class="list-number"><span>4.</span></div>
                                    </div>
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4"><span >{{ $t("faq.tab2.text7") }}</span></p>
                                        <p class="body-4"><span v-html="formatContent('faq.tab2.text7-1', $t, localPath)"></span></p>
                                        <p class="body-4"><span v-html="formatContent('faq.tab2.text7-2', $t, localPath)"></span></p>
                                        <p class="body-4"><span v-html="formatContent('faq.tab2.text7-3', $t, localPath)"></span></p>
                                        <p class="body-4"><span v-html="formatContent('faq.tab2.text7-4', $t, localPath)"></span></p>
                                        <p class="body-4"><span v-html="formatContent('faq.tab2.text7-5', $t, localPath)"></span></p>
                                        <p class="body-4"><span v-html="formatContent('faq.tab2.text7-6', $t, localPath)"></span></p>
                                        <picture class="min-image-desktop"><source media="(max-width: 570px)" srcset="/images/faq/New-user-guide-q2-04-movil.png"><img src="/images/faq/New-user-guide-q2-04.png" alt="Imagen 1" class="responsive-image"></picture>
                                        <p class="body-4"><span >{{ $t("faq.tab2.text8") }}</span></p>
                                        <Message severity="info">
                                            <template #icon>
                                                <span class="material-symbols-outlined" style="align-self: flex-start; margin-top: 0px; margin-right: 0px; color: #3b82f6;">error</span>
                                            </template>
                                            <p class="body-4"><span v-html="formatContent('faq.tab2.text9', $t, localPath)"></span></p>
                                            <p class="body-4"><span v-html="formatContent('faq.tab2.text9-1', $t, localPath)"></span></p>
                                        </Message>
                                        <picture class=""><source media="(max-width: 570px)" srcset="/images/faq/New-user-guide-q2-05.png"><img src="/images/faq/New-user-guide-q2-05.png" alt="Imagen 1" class="responsive-image"></picture>
                                        <picture class="d-none-desktop"><source media="(max-width: 570px)" srcset="/images/faq/New-user-guide-q2-07.jpg"><img src="" alt="Imagen 1" class="responsive-image"></picture>
                                        <p class="body-4"><span v-html="formatContent('faq.tab2.text10', $t, localPath)"></span></p>
                                    </div>
                                    </div>
                                </div>
                                <div class="icon-text">
                                    <div class="cont-icon">
                                    <span class="material-symbols-outlined icon" translate="no">send</span>
                                    <div class="list-number"><span>5.</span></div>
                                    </div>
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4"><span >{{ $t("faq.tab2.text11") }}</span></p>
                                        <picture class=""><source media="(max-width: 570px)" srcset="/images/faq/New-user-guide-q2-06-movil.jpg"><img src="/images/faq/New-user-guide-q2-06.png" alt="Imagen 1" class="responsive-image"></picture>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </FaqAccordion>
            <div class="accordeon container destock">
                <div class="content-main-tab">
                    <div class="tab-content">
                        <div class="contet-general">
                            <h1>{{ $t("faq.tab2.title1") }}</h1>
                            <div class="icon-text">
                                <div class="cont-icon">
                                <span class="material-symbols-outlined icon" translate="no">link</span>
                                <div class="list-number"><span>1.</span></div>
                                </div>
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4"><span v-html="formatContent('faq.tab2.text1', $t, localPath)"></span></p>
                                </div>
                                </div>
                            </div>
                            <div class="icon-text">
                                <div class="cont-icon">
                                <span class="material-symbols-outlined icon" translate="no">variable_insert</span>
                                <div class="list-number"><span>2.</span></div>
                                </div>
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4"><span >{{ $t("faq.tab2.text2") }}</span></p>
                                    <picture class=""><source media="(max-width: 570px)" srcset="/images/faq/New-user-guide-q2-01-movil.jpg"><img src="/images/faq/New-user-guide-q2-01.jpg" alt="Imagen 1" class="responsive-image"></picture>
                                    <p class="body-4"><span class="italic">{{ $t("faq.tab2.text3") }}</span></p>
                                    <!-- <p class="body-4"><span class="italic">{{ $t("faq.tab2.text4") }}</span></p>
                                    <p class="body-4"><span class="italic">{{ $t("faq.tab2.text5") }}</span></p> -->
                                </div>
                                </div>
                            </div>
                            <div class="icon-text">
                                <div class="cont-icon">
                                <span class="material-symbols-outlined icon" translate="no">password</span>
                                <div class="list-number"><span>3.</span></div>
                                </div>
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4"><span v-html="formatContent('faq.tab2.text6', $t, localPath)"></span></p>
                                    <picture class=""><source media="(max-width: 570px)" srcset="/images/faq/New-user-guide-q2-02-movil.png"><img src="/images/faq/New-user-guide-q2-02.png" alt="Imagen 1" class="responsive-image"></picture>
                                    <picture class=""><source media="(max-width: 570px)" srcset="/images/faq/New-user-guide-q2-03-movil.png"><img src="/images/faq/New-user-guide-q2-03.png" alt="Imagen 1" class="responsive-image"></picture>
                                </div>
                                </div>
                            </div>
                            <div class="icon-text">
                                <div class="cont-icon">
                                <span class="material-symbols-outlined icon" translate="no">clarify</span>
                                <div class="list-number"><span>4.</span></div>
                                </div>
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4"><span >{{ $t("faq.tab2.text7") }}</span></p>
                                    <p class="body-4"><span v-html="formatContent('faq.tab2.text7-1', $t, localPath)"></span></p>
                                    <p class="body-4"><span v-html="formatContent('faq.tab2.text7-2', $t, localPath)"></span></p>
                                    <p class="body-4"><span v-html="formatContent('faq.tab2.text7-3', $t, localPath)"></span></p>
                                    <p class="body-4"><span v-html="formatContent('faq.tab2.text7-4', $t, localPath)"></span></p>
                                    <p class="body-4"><span v-html="formatContent('faq.tab2.text7-5', $t, localPath)"></span></p>
                                    <p class="body-4"><span v-html="formatContent('faq.tab2.text7-6', $t, localPath)"></span></p>
                                    <picture class="min-image-desktop"><source media="(max-width: 570px)" srcset="/images/faq/New-user-guide-q2-04-movil.png"><img src="/images/faq/New-user-guide-q2-04.png" alt="Imagen 1" class="responsive-image"></picture>
                                    <p class="body-4"><span >{{ $t("faq.tab2.text8") }}</span></p>
                                    <Message severity="info">
                                        <template #icon>
                                            <span class="material-symbols-outlined" style="align-self: flex-start; margin-top: 0px; margin-right: 0px; color: #3b82f6;">error</span>
                                        </template>
                                        <p class="body-4"><span v-html="formatContent('faq.tab2.text9', $t, localPath)"></span></p>
                                        <p class="body-4"><span v-html="formatContent('faq.tab2.text9-1', $t, localPath)"></span></p>
                                    </Message>
                                    <picture class=""><source media="(max-width: 570px)" srcset="/images/faq/New-user-guide-q2-05-movil.png"><img src="/images/faq/New-user-guide-q2-05.png" alt="Imagen 1" class="responsive-image"></picture>
                                    <picture class="d-none-desktop"><source media="(max-width: 570px)" srcset="/images/faq/New-user-guide-q2-07.png"><img src="" alt="Imagen 1" class="responsive-image"></picture>
                                    <p class="body-4"><span v-html="formatContent('faq.tab2.text10', $t, localPath)"></span></p>
                                </div>
                                </div>
                            </div>
                            <div class="icon-text">
                                <div class="cont-icon">
                                <span class="material-symbols-outlined icon" translate="no">send</span>
                                <div class="list-number"><span>5.</span></div>
                                </div>
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4"><span >{{ $t("faq.tab2.text11") }}</span></p>
                                    <picture class=""><source media="(max-width: 570px)" srcset="/images/faq/New-user-guide-q2-06-movil.png"><img src="/images/faq/New-user-guide-q2-06.png" alt="Imagen 1" class="responsive-image"></picture>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> 
</template>

<script setup>
const { t, locale } = useI18n();
const route = useRoute();
const localPath = useLocalePath();
import Message from 'primevue/message';
import FaqAccordion from '~/components/faq/FaqAccordion.vue'

useFaqSeoMeta("faq.tab2.title1", "faq.tab2.text1");
</script>




